import { select, selectAll, addClass, removeClass } from 'modules/dom'

export default function (el) {
  const PROFESSIONAL_TEXT = 'professional_development'
  const MY_ACCOUNT_TEXT = 'my_account'
  const TABS_ELM = '.js-nav-tabs__link'
  const SIDEBAR_BANNER = '.js-dashboard-banner '
  const PROFESSIONAL_BUTTON = '.js-nav-tabs__link'
  const HIDDEN_CLASS = 'hidden'

  const tabs = selectAll(TABS_ELM)
  const sidebarBannerElm = select(SIDEBAR_BANNER, el)
  const professional_button = select(PROFESSIONAL_BUTTON, el)

  if (tabs.length && professional_button) {
    tabs.map((tab) => {
      tab.addEventListener('click', () => {
        const tabHref = tab.dataset.href
        if (tabHref === PROFESSIONAL_TEXT) {
          addClass(HIDDEN_CLASS, sidebarBannerElm)
          addClass(HIDDEN_CLASS, professional_button)
        } else {
          removeClass(HIDDEN_CLASS, sidebarBannerElm)
          removeClass(HIDDEN_CLASS, professional_button)
        }
        if (tabHref === MY_ACCOUNT_TEXT) {
          addClass(HIDDEN_CLASS, el)
        } else {
          removeClass(HIDDEN_CLASS, el)
        }
      })
    })
    professional_button.addEventListener('click', () => {
      addClass(HIDDEN_CLASS, professional_button)
      addClass(HIDDEN_CLASS, sidebarBannerElm)
    })
  }
}
